import type { QuoteData } from '../types/quote.types';

export const initialState: QuoteData = {
    quoteId: undefined,
    quoteRef: undefined,
    status: 'live',
    selectedDealer: null,
    selectedVehicle: null,
    selectedProduct: null,
    configuredServices: [],
    configuredAddOns: [],
    dismissedAutoAddOnIds: [],
    autoAddOnBaselinePending: false,
    draftId: '',
    version: undefined,
    saveDirty: false,
    resolvedPlanId: null,
    servicePlanSessionId: null,
    smriqConfirmedVehicle: null,
    smriqPlanSettings: null,
    paymentOptions: {
        startDate: new Date().toISOString(), // Store as ISO string
        depositAmount: 0,
        scheduleType: 'even',
    },
    selectedCustomer: null,
    // Optional keys must be present, or resetQuote's Object.assign leaves the
    // previous quote's values in place (they are absent, not overwritten).
    scheduleOverrides: undefined,
    paymentSelection: undefined,
    currentStep: 'dealer',
    completedSteps: [],
    isValid: false,
    errors: {
        dealer: [],
        vehicle: [],
        product: [],
        configuration: [],
        customer: [],
        payment: [],
        summary: [],
    },
};
